import { loadRemote, registerRemotes } from '@module-federation/enhanced/runtime';
import { bustUrlCache } from './bustUrlCache';
export async function loadRemoteModule(_ref) {
  let {
    module,
    scope,
    url,
    bustRemoteEntryCache,
    version
  } = _ref;
  const name = version ? "".concat(scope, "@").concat(version) : scope;
  registerRemotes([{
    name,
    entry: bustRemoteEntryCache ? bustUrlCache(url) : url,
    entryGlobalName: scope
  }], {
    force: bustRemoteEntryCache
  });
  const loadRemoteRequest = "".concat(name, "/").concat(module.replace('./', ''));
  const loadedRemote = await loadRemote(loadRemoteRequest);
  if (loadedRemote === null) {
    throw new Error("ExoSkeletonAPI Error: Failed to load remote \"".concat(module, "\" from scope \"").concat(name, "\". Load remote request: \"").concat(loadRemoteRequest, "\""));
  }
  return loadedRemote;
}
//# sourceMappingURL=loadRemoteModule.js.map